/* eslint-disable no-restricted-syntax */

import {
  AccountData,
  SearchAccountsProviderInterface,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { GraphQLClient } from "graphql-request";

import { AccountsMsSearchAccountsRequest } from "@/api/graphql/generated/graphql";

import { SearchAccountsQuery } from "./queries";

export class SearchAccountsProvider implements SearchAccountsProviderInterface {
  constructor(private graphqlClient: GraphQLClient) {}

  async search(number: string): Promise<AccountData | null> {
    const request: AccountsMsSearchAccountsRequest = {
      filters: {
        number: number,
      },
    };

    const result = await this.graphqlClient.request(SearchAccountsQuery, {
      request,
    });

    return (
      result.AccountsMsSearchAccounts?.data?.map((account) => ({
        accountId: account?.id ?? "",
        label: account?.name ?? "",
        number: account?.number ?? "",
      }))[0] ?? null
    );
  }
}
